import { Card } from "../../../../../components";
import { ScoreCard } from "../ScoreCard";

export const InvestmentConclusionScores = ({
  gatewayScore,
  shortConclusion,
  scores,
  isLoading,
}) => {
  return (
    <div className="flex flex-nowrap gap-4">
      <div className="flex">
        <Card className="p-6" secondary>
          <div className="flex flex-1 flex-col justify-center items-center gap-1">
            <span className=" text-[24px] font-bold leading-[32px] text-center text-[#007DFF]">
              {gatewayScore?.toFixed(2)}
            </span>
            <span className=" text-[12px] font-normal leading-[16px] text-center">
              Total
            </span>
          </div>
        </Card>
      </div>
      <div className="flex grow">
        <div className="flex grow flex-col gap-4">
          <div className="flex flex-col gap-1">
            <div className="flex gap-2 items-center flex-wrap sm:flex-nowrap">
              <span className=" text-[14px] font-normal leading-[20px] text-[#FFFFFF88]">
                Investment recommendation:
              </span>
              {/* TODO: Add data */}
              <span className="text-[16px] font-medium leading-[24px]">
                Moderate buy
              </span>
            </div>
            <p className="hidden sm:block">{shortConclusion}</p>
          </div>
          <div className="flex flex-col gap-1 hidden sm:block">
            <div className="flex flex-nowrap gap-2">
              <ScoreCard
                title="Technical Analysis"
                score={isLoading ? "0.0" : scores?.technicalAnalysis}
              />
              <ScoreCard
                title="Fundamental Analysis"
                score={isLoading ? "0.0" : scores?.fundamentalAnalysis}
              />
              <ScoreCard
                title="Social Score"
                score={isLoading ? "0.0" : scores?.socialScore}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
